module.exports = __webpack_public_path__ + "img/评审管理.e68759a1.jpg";